var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"background-color":"#f3f3f3","opacity":0.8,"loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('div',{staticClass:"map-margins",attrs:{"id":"polygon-label-map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }